export default __webpack_public_path__ + "static/Logo_TaxSheets-6564875ba7ed2de5fff6ab97adb6f692.png";